"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoPreview = void 0;
var React = require("react");
var classNames = require("classnames");
var VideoPreview = function (props) {
    return (React.createElement("div", { className: 'image-preview video' },
        React.createElement("div", { className: classNames('background') },
            React.createElement("video", { autoPlay: true, controls: true },
                React.createElement("source", { src: "".concat(__UPLOADSERVERURL__, "/files/").concat(props.revision.uuid, "?preview=true&v=").concat(Math.random()) }),
                "Your browser does not support the video tag."))));
};
exports.VideoPreview = VideoPreview;
exports.default = exports.VideoPreview;
